"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmTab = void 0;
const react_1 = __importStar(require("react"));
const SmTabItem_1 = require("./SmTabItem");
const useTab_1 = require("./useTab");
exports.SmTab = (0, react_1.forwardRef)((_a, ref) => {
    var { children, label, current = 0, onTabChange } = _a, props = __rest(_a, ["children", "label", "current", "onTabChange"]);
    const { tabButtons, activeContent, activeTitle } = (0, useTab_1.useTab)(label, children, current, onTabChange);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: "c-tab", ref: ref }),
        react_1.default.createElement("div", { role: "tablist", className: "c-tab__header", "aria-label": label }, tabButtons),
        react_1.default.createElement("div", { id: `${label}-tab`, tabIndex: 0, role: "tabpanel", "aria-label": activeTitle, className: "c-tab__panel" }, activeContent)));
});
exports.SmTab.Item = SmTabItem_1.SmTabItem;
//# sourceMappingURL=index.js.map